<template>
    <div class="rasoStep">
          <div class="rasoStep-flex flex align-cen">
            <div class="label isRequild">过程名称：</div>
            <div class="ipt">
                 <el-input placeholder="请输入过程名称" v-model="infoList.processName" clearable> </el-input>
            </div>
        </div>
        <!-- 起始条件 -->
                <div class="rasoStep-flex">
             <div class="label isRequild">起始条件</div>
             <div class="stepCond flex align-cen" 
             v-for="(item,index) in result0"
             >
                <div class="stepCond-1" v-if="item.cond1">
                     <el-select v-model="item.cond1" placeholder="请选择">
                        <el-option
                        v-for="item1 in stepCond"
                        :key="item1"
                        :label="item1"
                        :value="item1" 
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="stepCond-1" v-if="!item.cond1"></div>
                <div class="stepCond-2">
                      <el-select v-model="item.tag" filterable clearable placeholder="请选择" @change="classChange(index,0)">
                        <el-option
                        v-for="item2 in instrumentItem"
                        :key="item2.tag"
                        :label="item2.tag + ' ' +  item2.name"
                        :value="item2.tag" 
                        >
                        </el-option>
                    </el-select>
                </div>
                     <div class="stepCond-1">
                     <el-select v-model="item.tj" placeholder="请选择">
                        <el-option
                        v-for="item2 in stepCond1"
                        :key="item2"
                        :label="item2"
                        :value="item2" 
                        >
                        </el-option>
                    </el-select>
                </div>
                       <div class="stepCond-1" style="margin-left:15px">
                     <el-input placeholder="" v-model="item.tj1" clearable> </el-input>
                     </div>
                     <div class="stepCond-3" v-if="index > 0" @click="deletResult(index,0)">
                        <i class="el-icon-error"></i>
                     </div>
             </div>
             <div class="add-stepCond" @click="addStepCond(0)">
                添加一项
             </div>
                     <!-- 目标条件 -->
          <div class="rasoStep-flex">
             <div class="label isRequild">结束条件：</div>
                       <div class="stepCond flex align-cen" 
             v-for="(item,index) in result1"
             >
                <div class="stepCond-1" v-if="item.cond1">
                     <el-select v-model="item.cond1" placeholder="请选择">
                        <el-option
                        v-for="item1 in stepCond"
                        :key="item1"
                        :label="item1"
                        :value="item1" 
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="stepCond-1" v-if="!item.cond1"></div>
                <div class="stepCond-2">
                      <el-select v-model="item.tag" filterable clearable placeholder="请选择" @change="classChange(index,1)">
                        <el-option
                        v-for="item2 in instrumentItem"
                        :key="item2.tag"
                        :label="item2.tag + ' ' +  item2.name"
                        :value="item2.tag" 
                        >
                        </el-option>
                    </el-select>
                </div>
                     <div class="stepCond-1">
                     <el-select v-model="item.tj" placeholder="请选择">
                        <el-option
                        v-for="item2 in stepCond1"
                        :key="item2"
                        :label="item2"
                        :value="item2" 
                        >
                        </el-option>
                    </el-select>
                </div>
                       <div class="stepCond-1" style="margin-left:15px">
                     <el-input placeholder="" v-model="item.tj1" clearable> </el-input>
                     </div>
                     <div class="stepCond-3" v-if="index > 0" @click="deletResult(index,1)">
                        <i class="el-icon-error"></i>
                     </div>
             </div>
                <div class="add-stepCond" @click="addStepCond(1)">
                添加一项
             </div>
               <div class="rasoStep-flex flex align-cen" v-if="propId && !propSort">
            <div class="label isRequild">排序：</div>
            <div class="ipt">
                 <el-input placeholder="`请输入过程排序" v-model="infoList.sort" clearable> </el-input>
            </div>
        </div>
          </div>
        </div>
    </div>
</template>
<script>
import {instrumentList,getProcess,editProcess} from "@/api/index/index"   //仪表阀门列表、过程详情、新增编辑
import debounce from '../utils/debounce.js' //防抖
export default {
    name:'rasoProcess',
      props: {
    propId:[String, Number],
    propAppId:[String, Number],
    propSort:[String, Number],
      },
    data() {
        return {
        stepCond:['与','或'],
        instrumentItem:[],
        result0:[
            {
            cond1:'',  
            tag: '',  
            name:'',  
            tj:'=',  
            tj1: '' 
            },
            {
                cond1:'与',  
                tag: '',  
                name:'',  
                tj:'=',  
                tj1: ''
                }
        ],
        result1:[
            {
             cond1:'',  
            tag: '',  
            name:'',  
            tj:'=',  
            tj1: '' 
            },{
                cond1:'与',  
                tag: '',  
                name:'',  
                tj:'=',  
                tj1: ''
                }
        ],
        stepCond1:['=','>','<','>=','<='],
        infoList:{
            processName:'',
            startCondition:'',
            endCondition:'',
            sort:''
        }
    }
    },
    created() {
         this.getinstrumentList();
        if(this.propId) this.getProcessDetai(this.propId,'get')
    },
    methods: {
        emitData(){

            if(!this.infoList.processName) return this.$util.Notifi('请输入过程名称', "error", "fa-exclamation-circle");  
            if(!this.infoList.sort && this.propId ) return this.$util.Notifi('请输入过程排序', "error", "fa-exclamation-circle");  
        let newarr = ['startCondition','endCondition']
        let continueExecution = true; // 标志变量，用于指示是否继续执行后续代码  
            for (let index = 0; index < newarr.length; index++) {  
                let t = newarr[index]; 
                let r = this[`result${index}`]
                for (let  index1 in r) {
                if(!r[index1].tag || !r[index1].tj1){
                this.$util.Notifi(index == 0 ? `请补全第${Number(index1) + 1}条起始条件` : `请补全第${Number(index1) + 1}条结束条件`, "error", "fa-exclamation-circle");
                continueExecution = false;
                break;
                } 
                }
                if(!continueExecution){
                    break; // 退出循环 
                }else{
                let formattedStrings = this[`result${index}`].map(item => `${item.cond1},${item.tag},${item.name},${item.tj},${item.tj1}`);
                this.infoList[t] = formattedStrings.join(';');
                }
            }
            if(this.propSort) this.infoList.sort = this.propSort
            let params = {
                paperId:this.$route.query.twoId,
                processName:this.infoList.processName,
                startCondition:this.infoList.startCondition,
                endCondition:this.infoList.endCondition,
                sort:this.propId ? this.infoList.sort : ''
            }
            let method = "post"
            if(!this.propId || this.propSort)  params = {...params},method = "post";
            if(this.propId && !this.propSort) params = {...params,id:this.infoList.id}, method = "put";
             //防抖提交
             if (continueExecution) { 
                debounce(() => {
                 this.commentBness(params,method)
            }, 500)
              }
        },
             commentBness(params,method){
                editProcess(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.$util.Notifi(`${this.propId ? '编辑' : '新增'}成功`,'success','fa-check')
                             this.$emit('emitFun', this.infoList);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                        })
        },
        // 新增修改公共函数
         // 条件筛选
        classChange(index,type){
            // type:0起始条件，1结束条件
            this.instrumentItem.filter(item =>{
               if(item.tag == this[`result${type}`][index].tag){
                this[`result${type}`][index].name = item.name
               }
            })
        },
           // 删除前提条件选项
        deletResult(index,type){
              let delet= this[`result${type}`].filter((item,sy)=> sy != index) 
              this[`result${type}`] = delet
        },
        // 添加前提条件
        addStepCond(type){
                this[`result${type}`].push({
                cond1: "与",
                tag: "",
                name:"",
                tj:"=",
                tj1:""
            });
        },
        // 获取过程详情
        getProcessDetai(id,method){
            getProcess({id:id},method)
            .then(res =>{
                console.log(res)
                this.infoList = res.data
                let newarr = ['startCondition','endCondition']
                newarr.forEach((t,index) =>{
                this[`result${index}`] = []
                let str = this.infoList[t]
                    let arr = []
                    str = str.trim().replace(/;$/, '');  
                    arr = str.split(';')
                    this[`result${index}`] = arr.map(item =>{
                        // 分割字符串为数组，
                        let parts = item.split(',');
                        // 构造对象  
                            return {  
                                cond1: parts[0],  
                                tag: parts[1],  
                                name: parts[2],  
                                tj: parts[3],  
                                tj1: parts[4]  
                            };
                    })
                    })
                        })
        },
        // 获取阀门列表
          getinstrumentList(){
            instrumentList({appId:this.propAppId,search:''})
            .then(res =>{
                this.instrumentItem = res.data
            })
        },
    },
  }

</script>
<style lang="scss" scoped>
.rasoStep{
    height: 70vh;
    overflow-y: scroll;
    margin-bottom: 10px;
.rasoStep-flex{
    padding-bottom: 10px;
    padding-left: 10px;
    .label{
        position: relative;
        font-weight: bold;
    }
    .isRequild::before{
        content: '*';
        color: #f56c6c;
        position: absolute;
        left: -10px;
        font-size: 16px;
        font-weight: bold;
        
    }
}
.stepCond{
     padding: 15px 0 0 0;
     .stepCond-2{
        margin: 0 15px;
     }
     .stepCond-3{
        margin-left: 15px;
        font-size: 18px;
        cursor: pointer;
     }
}
.add-stepCond{
    display: block;
    margin-left: 115px;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 150px;
    text-align: center;
    color: #fff;
    height: 40px;
    border-radius: 4px;
    background-color: #36aafd;
    line-height: 40px;
    cursor: pointer;
}
}
::v-deep{
    .stepCond-1{
        width: 100px;
        .el-select{
            text-align: center;
            .el-input--suffix .el-input__inner{
                text-align: center;
            }
        }
    }
}
</style>